//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	export default {
		data() {
			return {
				activeMainCategory: '',
				activeSubCategory: '',
				mainCategories: [],
				subCategories: {},
				softwareList: [],
				softwareLoading: true
			}
		},
		computed: {
			currentSubCategories() {
				return this.subCategories[this.activeMainCategory] || [];
			}
		},
		methods: {
			changeMainCategory(categoryId) {
				this.activeMainCategory = categoryId;
				// 切换到主分类时，默认选择第一个子分类
				if (this.currentSubCategories.length > 0) {
					this.activeSubCategory = this.currentSubCategories[0].IDCode;
					this.getSoftwareList();
				}
				
			},
			changeSubCategory(subCategoryId) {
				this.activeSubCategory = subCategoryId;
				this.getSoftwareList();
			},
			getSoftwareList() {
				this.softwareLoading = true;
				this.$tyh.CourseGetGroup(this.activeSubCategory)
					.then((data) => {
						this.softwareList = data.data.Data;
						this.softwareLoading = false;
					})
			},
			selectSoftware(softwareId,softwareName) {
				let Level1Name = this.mainCategories.find(t => t.IDCode == this.activeMainCategory).Name;
				let Level2Name=this.subCategories[this.activeMainCategory].find(t => t.IDCode == this.activeSubCategory).Name;
				let Level3Name=softwareName;

 				this.$router.push({
					path: '/Index/CourseList',
					name: '/Index/CourseList',
					params: {
						cougroupIDCode: softwareId,
						level1: Level1Name,
						level2: Level2Name,
						level3: Level3Name,
						tabSelected: this.activeMainCategory,
						idCode: softwareId,
						levelID: 1,
						nowIndex1: -1,
						nowIndex2: -1
					}
				}) 

			}
		},
		mounted() {
			//先获取快速导航信息
			this.$tyh.CourseGetNav()
				.then((data) => {

					let dataArray = data.data.Data;

					this.mainCategories = dataArray.map(item => ({
						IDCode: item.IDCode,
						Name: item.Name
					}));

					this.subCategories = dataArray.reduce((acc, item) => {
						acc[item.IDCode] = item.Sub;
						return acc;
					}, {});

					// 初始化默认选择第一个子分类
					if (dataArray.length > 0) {
						this.activeMainCategory = dataArray[0].IDCode;
						this.activeSubCategory = dataArray[0].Sub[0].IDCode;
						this.getSoftwareList();
					}
				})

		}
	}



// WEBPACK FOOTER //
// ./src/views/Class/Course.vue